import React, {useState} from "react";
import questions from "../assets/questions.svg"
import retracted from "../assets/retracted.svg"
import expanded from "../assets/expanded.svg"
import InfoRightPopUp from "./InfoRightPopUp"
import {useEffect} from "react";
import SubscriptionNeededPopup from "./SubscriptionNeededPopup";

const SummaryTabular = (props) => {

    const cardData = props.cardData
    const showQuestions = props.showQuestions
    const cardType = props.cardType
    const generatingReport = props.generatingReport
    const origin = props.origin || "chart" // Fallback in case something goes seriously wrong
    const subscription = props.subscription;

    const [attributableData, setAttributableData] = useState(false)
    const [showTeamMembers, setShowTeamMembers] = useState(true)
    const [showTeamLeaders, setShowTeamLeaders] = useState(true)
    const [showStakeholders, setShowStakeholders] = useState(true)

    const [teamMemberExpanded, setTeamMemberExpanded] = useState(generatingReport)
    const [teamLeaderExpanded, setTeamLeaderExpanded] = useState(generatingReport)
    const [stakeholderExpanded, setStakeholderExpanded] = useState(generatingReport)

    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);


    useEffect(() => { // Extra to ensure it really updates to true
        if (generatingReport) {
            setTeamMemberExpanded(true);
            setTeamLeaderExpanded(true);
            setStakeholderExpanded(true);
        }
    }, [generatingReport]);

    const getPillarColour = (pillar_id) => {
        switch (pillar_id) {
            case 1: return "blue"
            case 2: return "red"
            case 3: return "green"
            case 4: return "purple"
            case 5: return "pink"
            case 6: return "orange"
        }
    }



    const normal_round = (value) => {
        if (value === null || value === undefined || isNaN(value)) return "N/A";
        if (value - Math.floor(value) < 0.5) return Math.floor(value);
        return Math.ceil(value)
    }

    const avgScore = (scores) => {
        if (!scores) return;

        let count = scores.length;
        let total = 0;
        for(const score of scores){
            total += score.score && score.score ? score.score : score;
        }

        if (!count || !total) return "N/A"
        return Math.round(total / count);
    }

    const getFunctionScore = (score) => {
        let _function_level
        if(score < 20) {
            _function_level = "Low"
        } else if(score < 40) {
            _function_level = "Medium"
        } else {
            _function_level = "High"
        }

        return _function_level
    }

    const getOverallTeamMean = (theme) => {
        let scores = []
        if(showTeamMembers) {
            scores = [...scores, ...theme.team_member_scores]
        }
        if(showTeamLeaders) {
            scores = [...scores, ...theme.team_leader_scores]
        }
        if(showStakeholders) {
            scores = [...scores, ...theme.stakeholder_scores]
        }
        return avgScore(scores)
    }

    const getTeamMean = (theme) => {
        let scores = []
        if(showTeamMembers) {
            scores = [...scores, ...theme.team_member_scores]
        }
        if(showTeamLeaders) {
            scores = [...scores, ...theme.team_leader_scores]
        }
        return avgScore(scores)
    }

    const getStakeholderMean = (theme) => {
        let scores = []
        if(showStakeholders) {
            scores = [...scores, ...theme.stakeholder_scores]
        }
        return avgScore(scores)
    }

    const getOverallTeamVariance = (theme) => {
        let people = []
        if(showTeamMembers) {
            people = [...people, ...theme.team_member_scores]
        }
        if(showTeamLeaders) {
            people = [...people, ...theme.team_leader_scores]
        }
        if(showStakeholders) {
            people = [...people, ...theme.stakeholder_scores]
        }
        let scores = []
        for(const person of people){
            scores.push(person.score)
        }
        if (!scores.length) return "N/A"

        let min = Math.min(...scores)
        let max = Math.max(...scores)
        let variance = max - min

        if (!variance) {variance = "N/A"}

        return variance
    }

    const getTeamVariance = (theme) => {
        let people = []
        if(showTeamMembers) {
            people = [...people, ...theme.team_member_scores]
        }
        if(showTeamLeaders) {
            people = [...people, ...theme.team_leader_scores]
        }
        let scores = []
        for(const person of people){
            scores.push(person.score)
        }
        if (!scores.length) return "N/A"

        let min = Math.min(...scores)
        let max = Math.max(...scores)
        let variance = max - min

        if (!variance) {variance = "N/A"}

        return variance
    }

    const getStakeholderVariance = (theme) => {
        if (!showStakeholders || !showTeamMembers || !showTeamLeaders) return "N/A"

        let teamMean = getTeamMean(theme)
        let stakeholderMean = getStakeholderMean(theme)
        let variance = Math.abs(teamMean - stakeholderMean)

        if (!variance) {variance = "N/A"}

        return variance
    }

    const goToQuestions = () => {
        if (!props.seeQuestions) return
        // Back-compat: if parent only accepts one arg, keep working.
        if (props.seeQuestions.length >= 2) {
            props.seeQuestions(cardType, origin);
        } else {
            props.seeQuestions(cardType)
        }
    };

    const handleAttributableToggle = () => {
        if (subscription < 1) {
            setShowSubscriptionPopup(true);
            return;
        }

        setAttributableData(!attributableData);
    };

    return (
        <div className="summary-tabular-container" style={{width: generatingReport ? "100%" : null, padding: generatingReport ? "30px" : null}}>
            <div className="summary-tabular-header-container">
                <div className="summary-tabular-title-container">
                    <div className="summary-tabular-title">Tabular</div>
                    <div className="summary-tabular-attributable-switch" style={{opacity: generatingReport ? 0 : null}}>
                        <div className={`chart-controls-switch ${attributableData ? "active" : "inactive"}`}
                             onClick={handleAttributableToggle}>
                            <div className="chart-controls-switch-centre"/>
                        </div>
                        <div className="summary-tabular-attributable-switch-text">Attributable Data</div>
                    </div>
                </div>
                <div className="summary-tabular-controls-container">
                    <div className="summary-tabular-control-container">
                        <div className="summary-tabular-controls-switch" style={{display: generatingReport ? "none" : null}}>
                            <div className={`chart-controls-switch ${showTeamMembers ? "active" : "inactive"}`}
                                 onClick={() => setShowTeamMembers(!showTeamMembers)}>
                                <div className="chart-controls-switch-centre"/>
                            </div>
                        </div>
                        <div className="summary-tabular-controls-text-container">
                            <div className="summary-tabular-colour-circle green"/>
                            <div className="summary-tabular-controls-text">Team Members</div>
                        </div>
                    </div>
                    <div className="summary-tabular-control-container">
                        <div className="summary-tabular-controls-switch" style={{display: generatingReport ? "none" : null}}>
                            <div className={`chart-controls-switch ${showTeamLeaders ? "active" : "inactive"}`}
                                 onClick={() => setShowTeamLeaders(!showTeamLeaders)}>
                                <div className="chart-controls-switch-centre"/>
                            </div>
                        </div>
                        <div className="summary-tabular-controls-text-container">
                            <div className="summary-tabular-colour-circle pink"/>
                            <div className="summary-tabular-controls-text">Team Leader(s)</div>
                        </div>
                    </div>
                    <div className="summary-tabular-control-container">
                        <div className="summary-tabular-controls-switch" style={{display: generatingReport ? "none" : null}}>
                            <div className={`chart-controls-switch ${showStakeholders ? "active" : "inactive"}`}
                                 onClick={() => setShowStakeholders(!showStakeholders)}>
                                <div className="chart-controls-switch-centre"/>
                            </div>
                        </div>
                        <div className="summary-tabular-controls-text-container">
                            <div className="summary-tabular-colour-circle blue"/>
                            <div className="summary-tabular-controls-text">Stakeholder(s)</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="summary-tabular-top-row">
                <div
                    className="summary-tabular-see-questions-container link"
                    onClick={goToQuestions}
                >
                    {showQuestions && !generatingReport ? (
                        <>
                            <div className="summary-tabular-questions-icon-background">
                                <img src={questions} alt="View Questions" />
                            </div>
                            <div className="summary-tabular-icon-text">See Questions</div>
                        </>
                    ) : null}
                </div>
                {cardData && cardData.themes.map((theme, idx) => {
                    return <div className="summary-tabular-section-column" key={idx}>{theme.name}</div>
                })}
            </div>
            <div className="summary-tabular-colour-row">
                <div className="summary-tabular-filler-row large"/>
                {cardData && cardData.themes.map((theme, idx) => {
                    return (
                        <div className="summary-tabular-section-column" key={idx}>
                            <div className={`summary-tabular-pillar-colour ${getPillarColour(theme.pillar_id)}`}/>
                        </div>
                    )
                })}
            </div>
            {showTeamMembers ?
                <>
                    <div className="summary-tabular-colour-border-container">
                        <div className="summary-tabular-short-border green"/>
                        <div className={`summary-tabular-long-border green ${teamMemberExpanded ? "active" : ""}`}/>
                    </div>
                    <div className="summary-tabular-team-member-row mean">
                        <div className="team-member-row-click-container">
                            <div className="summary-tabular-expand-circle green link" style={{opacity: generatingReport ? 0 : null}}
                                 onClick={() => setTeamMemberExpanded(!teamMemberExpanded)}>
                                <img src={teamMemberExpanded ? expanded : retracted}
                                     alt={teamMemberExpanded ? "Retract" : "Expand"}
                                     className={teamMemberExpanded ? "expanded-icon" : "retracted-icon"}/>
                            </div>
                            <div className="team-member-row-name-container">Team Member Mean</div>
                        </div>
                        {cardData && cardData.themes.map((theme, idx) => {
                            return (
                                <div className="summary-tabular-section-column" key={idx}>
                                    {normal_round(avgScore(theme.team_member_scores))}
                                </div>
                            )
                        })}
                    </div>
                    {teamMemberExpanded ?
                        <>
                            {cardData && cardData.themes[0].team_member_scores.map((tm, tm_idx) => {
                                return (
                                    <div className="summary-tabular-team-member-row" key={tm_idx}>
                                        <div className="summary-tabular-row-name">
                                            {attributableData ? tm.name : `Team Member ${tm_idx + 1}`}
                                        </div>
                                        {cardData && cardData.themes.map((theme, idx) => {
                                            return (
                                                <div className="summary-tabular-section-column" key={idx}>
                                                    {theme.team_member_scores[tm_idx].score === 0 ? "N/A"
                                                        : normal_round(theme.team_member_scores[tm_idx].score)}
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                            })}
                        </> : null
                    }
                </> : null
            }
            {showTeamLeaders ?
                <>
                    <div className="summary-tabular-colour-border-container dark">
                        <div className="summary-tabular-short-border pink"/>
                        <div className={`summary-tabular-long-border pink ${teamLeaderExpanded ? "active" : ""}`}/>
                    </div>
                    <div className="summary-tabular-team-leader-row mean">
                        <div className="team-member-row-click-container">
                            <div className="summary-tabular-expand-circle pink link" style={{opacity: generatingReport ? 0 : null}}
                                 onClick={() => setTeamLeaderExpanded(!teamLeaderExpanded)}>
                                <img src={teamLeaderExpanded ? expanded : retracted}
                                     alt={teamLeaderExpanded ? "Retract" : "Expand"}
                                     className={teamLeaderExpanded ? "expanded-icon" : "retracted-icon"}/>
                            </div>
                            <div className="team-member-row-name-container">Team Leader Mean</div>
                        </div>
                        {cardData && cardData.themes.map((theme, idx) => {
                            return (
                                <div className="summary-tabular-section-column" key={idx}>
                                    {normal_round(avgScore(theme.team_leader_scores))}
                                </div>
                            )
                        })}
                    </div>
                    {teamLeaderExpanded ?
                        <>
                            {cardData && cardData.themes[0].team_leader_scores.map((tl, tl_idx) => {
                                return (
                                    <div className="summary-tabular-team-member-row" key={tl_idx}>
                                        <div className="summary-tabular-row-name">
                                            {attributableData ? tl.name : `Team Leader ${tl_idx + 1}`}
                                        </div>
                                        {cardData && cardData.themes.map((theme, idx) => {
                                            return (
                                                <div className="summary-tabular-section-column" key={idx}>
                                                    {normal_round(theme.team_leader_scores[tl_idx].score)}
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                            })}
                        </> : null
                    }
                </> : null
            }
            {showStakeholders ?
                <>
                    <div className="summary-tabular-colour-border-container">
                        <div className="summary-tabular-short-border blue"/>
                        <div className={`summary-tabular-long-border blue ${stakeholderExpanded ? "active" : ""}`}/>
                    </div>
                    <div className="summary-tabular-team-member-row mean">
                        <div className="team-member-row-click-container">
                            <div className="summary-tabular-expand-circle blue link" style={{opacity: generatingReport ? 0 : null}}
                                 onClick={() => setStakeholderExpanded(!stakeholderExpanded)}>
                                <img src={stakeholderExpanded ? expanded : retracted}
                                     alt={stakeholderExpanded ? "Retract" : "Expand"}
                                     className={stakeholderExpanded ? "expanded-icon" : "retracted-icon"}/>
                            </div>
                            <div className="team-member-row-name-container">Stakeholder Mean</div>
                        </div>
                        {cardData && cardData.themes.map((theme, idx) => {
                            return (
                                <div className="summary-tabular-section-column" key={idx}>
                                    {normal_round(avgScore(theme.stakeholder_scores))}
                                </div>
                            )
                        })}
                    </div>
                    {stakeholderExpanded ?
                        <>
                            {cardData && cardData.themes[0].stakeholder_scores.map((st, st_idx) => {
                                return (
                                    <div className="summary-tabular-team-member-row" key={st_idx}>
                                        <div className="summary-tabular-row-name">
                                            {attributableData ? st.name : `Stakeholder ${st_idx + 1}`}
                                        </div>
                                        {cardData && cardData.themes.map((theme, idx) => {
                                            return (
                                                <div className="summary-tabular-section-column" key={idx}>
                                                    {normal_round(theme.stakeholder_scores[st_idx].score)}
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                            })}
                        </> : null
                    }
                </> : null
            }
            <div className="summary-tabular-spacer-border"/>
            <div className="summary-tabular-team-row mean">
                <div className="summary-tabular-row-name">
                    <span className="summary-tabular-row-name-label">
                                {(cardData && cardData.group_name === "Variance with Stakeholder") || (cardData && cardData.group_name === "Variance with Team")
                                    ? "Full Team Mean"
                                    : "Overall Team Mean"}
                        <InfoRightPopUp
                            text={
                                (cardData && cardData.group_name === "Variance with Stakeholder") || (cardData && cardData.group_name === "Variance with Team")
                                    ? "This shows the combined mean scores across the selected participant groups " +
                                    "from the Full Team (Team Members and Team Leaders)"
                                    : "This shows the combined mean scores across all selected participant groups - " +
                                    "Team Members, Team Leaders and Team stakeholders."
                            }/>
                    </span>
                </div>
                {cardData && cardData.themes.map((theme, idx) => {
                    return (
                        <div className="summary-tabular-section-column" key={idx}>
                            {(cardData && cardData.group_name === "Variance with Stakeholder") || (cardData && cardData.group_name === "Variance with Team")
                                ? normal_round(getTeamMean(theme))
                                : normal_round(getOverallTeamMean(theme))}
                        </div>
                    )
                })}
            </div>
            {cardData && cardData.group_name === "Variance with Stakeholder" ?
                <>
                    <div className="summary-tabular-variance-row">
                        <div className="summary-tabular-row-name variance">
                            Stakeholder Variance
                            <span>
                                <InfoRightPopUp text={"This shows the variance between the Full Team Mean and the Stakeholder Mean."}/>
                            </span>
                        </div>
                        {cardData && cardData.themes.map((theme, idx) => {
                            return (
                                <div className="summary-tabular-section-column" key={idx}>
                                    {normal_round(getStakeholderVariance(theme))}
                                </div>
                            )
                        })}
                    </div>
                </> :
                <>
                    <div className="summary-tabular-variance-row">
                        <div className="summary-tabular-row-name variance">
                            <span className="summary-tabular-row-name-label">
                                {(cardData && cardData.group_name === "Variance with Stakeholder") || (cardData && cardData.group_name === "Variance with Team")
                                    ? "Full Team Variance"
                                    : "Overall Team Variance"}
                                <InfoRightPopUp
                                    text={
                                        (cardData && cardData.group_name === "Variance with Stakeholder") || (cardData && cardData.group_name === "Variance with Team")
                                            ? "This shows the variance between the highest and lowest scores across " +
                                            "the selected participant groups from the Full Team (Team Members and Team Leaders)."
                                            : "This shows the variance between the highest and lowest scores across " +
                                            "all selected participant groups - Team Members, Team Leaders and Team stakeholders."
                                    }/>
                            </span>
                        </div>
                        {cardData && cardData.themes.map((theme, idx) => {
                            return (
                                <div className="summary-tabular-section-column" key={idx}>
                                    {(cardData && cardData.group_name === "Variance with Stakeholder") || (cardData && cardData.group_name === "Variance with Team")
                                        ? normal_round(getTeamVariance(theme))
                                        : normal_round(getOverallTeamVariance(theme))}
                                </div>
                            )
                        })}
                    </div>
                </>
            }
            <div className="summary-tabular-function-row mean">
                <div className="summary-tabular-row-name">Function</div>
                {cardData && cardData.themes.map((theme, idx) => {
                    return (
                        <div className="summary-tabular-section-column" key={idx}>
                            {getFunctionScore(getOverallTeamMean(theme))}
                        </div>
                    )
                })}
            </div>
            {showSubscriptionPopup && (
                <SubscriptionNeededPopup
                    onClose={() => setShowSubscriptionPopup(false)}
                />
            )}
        </div>
    )
}

export default SummaryTabular